import React, { MouseEventHandler } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import SecondaryButton from 'components/Buttons/SecondaryButton';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { translate } from 'containers/services/translate';
import messages from 'containers/common/LegalProceedings/messages';
import { BUTTON_COLORS } from 'constants/design';
import { IntlMessage } from 'containers/LawyerLegalProceedingsPage/typings';

export interface JudgementValidationButtonsProps {
  intl: IntlShape;
  validateMessage?: IntlMessage;
  cancelMessage?: IntlMessage;
  onValidation?: MouseEventHandler;
  onCancel?: MouseEventHandler;
  isValidationDisabled?: boolean;
}

export const JudgementValidationButtons: React.FC<JudgementValidationButtonsProps> = (
  props,
): JSX.Element => {
  const validationMessage = !props.validateMessage
    ? messages.validate
    : props.validateMessage;
  const cancelMessage = !props.cancelMessage
    ? messages.previous
    : props.cancelMessage;

  return (
    <div className="validation-buttons-wrapper">
      <SecondaryButton
        title={translate(cancelMessage, props)}
        lefticon={<ArrowBackIosIcon className="left-icon" />}
        onClick={props.onCancel}
      />
      <PrimaryButton
        title={translate(validationMessage, props)}
        onClick={props.onValidation}
        righticon={<ArrowForwardIosIcon className="right-icon" />}
        background={BUTTON_COLORS.PRIMARY_BLUE}
        border={BUTTON_COLORS.PRIMARY_BLUE}
        titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
        disabled={props.isValidationDisabled}
      />
    </div>
  );
};

export default injectIntl(JudgementValidationButtons);
